import './polyfills';

import { AvailableLocale, Translations } from '../language-provider/shared';
import enUSTranslationMessages from '../translations/compiled/en-US.json';
import esESTranslationMessages from '../translations/compiled/es-ES.json';
import frFRTranslationMessages from '../translations/compiled/fr-FR.json';
import htHTTranslationMessages from '../translations/compiled/ht-HT.json';
import itITTranslationMessages from '../translations/compiled/it-IT.json';
import plPLTranslationMessages from '../translations/compiled/pl-PL.json';
import ptBRTranslationMessages from '../translations/compiled/pt-BR.json';

export const translationMessages: Translations = {
  'en-US': enUSTranslationMessages,
  'fr-FR': frFRTranslationMessages,
  'es-ES': esESTranslationMessages,
  'it-IT': itITTranslationMessages,
  'pl-PL': plPLTranslationMessages,
  'pt-BR': ptBRTranslationMessages,
  'ht-HT': htHTTranslationMessages,
};

export const appLocales = Object.keys(translationMessages) as AvailableLocale[];
